import { TimeAgo } from '@/components/time-ago';
import { DataSource } from '@/models/dataSource';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { DataSourceNameColumn } from './columns';
import { DataSourceRapidActionsColumn } from './columns/DataSourceRapidActionsColumn';
import { DataSourceStatusBadge } from '../../commons';

const columnHelper = createColumnHelper<DataSource>();

export const getDataSourcesTableColumns = (t: TFunction) =>
  [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => t('data_sources:table.data_source_name'),
      cell: ({ row }) => <DataSourceNameColumn datasource={row.original} />,
      minSize: 550,
      maxSize: 550,
    }),
    columnHelper.accessor('id', {
      id: 'id',
      header: () => t('data_sources:table.id'),
      cell: ({ row }) => <p className='text-sm text-tertiary-600'>{row.original.id}</p>,
      minSize: 130,
      maxSize: 130,
    }),
    columnHelper.accessor('createdOn', {
      id: 'createdOn',
      header: () => t('data_sources:table.data_source_created_at'),
      cell: ({ getValue }) => <TimeAgo time={getValue()} format='yyyy-MM-dd' />,
      minSize: 150,
      maxSize: 150,
      meta: {
        className: () => 'text-tertiary-600',
      },
    }),
    columnHelper.accessor('status', {
      id: 'status',
      header: () => t('data_sources:table.data_source_status'),
      cell: ({ row }) => <DataSourceStatusBadge status={row.original.status} />,
      minSize: 150,
      maxSize: 150,
      meta: {
        className: () => 'text-tertiary-600',
      },
    }),
    columnHelper.display({
      id: 'rapidActions',
      header: () => t('COMMON:table.rapidActions'),
      cell: ({ row }) => <DataSourceRapidActionsColumn datasource={row.original} />,
      minSize: 120,
      maxSize: 120,
      meta: {
        className: () => 'font-semibold',
        align: 'center',
      },
    }),
  ] as ColumnDef<DataSource>[];
